import { render, staticRenderFns } from "./AnalyzeUploadImage.vue?vue&type=template&id=71f71b6c&scoped=true&"
import script from "./AnalyzeUploadImage.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeUploadImage.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeUploadImage.vue?vue&type=style&index=0&id=71f71b6c&prod&lang=scss&scoped=true&"
import style1 from "./AnalyzeUploadImage.vue?vue&type=style&index=1&id=71f71b6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f71b6c",
  null
  
)

export default component.exports